import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "size", "color", "loading", "tooltipTitle", "loaderSize", "isEnableCss", "disabled"];
import { IconButton, Tooltip } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { MuiStack } from "./stackComponent";
export var MuiIconButton = function (props) {
    var children = props.children, size = props.size, color = props.color, loading = props.loading, tooltipTitle = props.tooltipTitle, loaderSize = props.loaderSize, _a = props.isEnableCss, isEnableCss = _a === void 0 ? true : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Tooltip, {
        title: tooltipTitle
    }, loading !== "loading" ? /*#__PURE__*/ React.createElement(IconButton, _extends({
        disabled: disabled,
        size: size || "medium",
        sx: {
            color: color || "black",
            height: "fit-content",
            opacity: disabled ? 0.5 : 1
        }
    }, other), children) : isEnableCss ? /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            margin: '5px'
        }
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: loaderSize || 30
    })) : /*#__PURE__*/ React.createElement(CircularProgress, {
        size: loaderSize || 30
    }));
};
